export enum ApiErrorCode {
  INVENTORY_OUT_OF_STOCK = 'inventory_out_of_stock',
  ONLY_ACCEPT_CLIENT_AUTH = 'only_accept_client_auth',
  VOUCHER_INVAID = 'voucher_invalid',
  NOCODB_UPLOAD_FAILED = 'nocodb_upload_failed'
}
